// import { DataNode } from "antd/lib/tree";
// import { Filter } from "../Api";

export function arrayParamAjust<T>(array?: T[]): T[] | undefined {
    return array && array.length > 0 ? array : undefined;
}

// export function filtersToDataNodes(array: Filter[]) : DataNode[] {
//     return array.map(x => ({ key: x.key!, title: x.title!, children: Array.from(x.children ?? []).map(y => ({ key: y.key!, title: y.title! })) }));
// }